import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useReferralsInsightsStore } from 'stores/referralsInsightsStore';
import { BodySmallBold } from 'styles/typography';

import { getReferralExportFilename, getReferralExportParams, VIEW_BY_DIMENSION_MAP } from '../constants';
import ReferralApiExport from '../ReferralApiExport';

export default function ReferralDetailsHeader() {
  const startDate = useReferralsInsightsStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useReferralsInsightsStore((state) => state.filters[END_DATE]) as Date;
  const viewBy = useReferralsInsightsStore((state) => state.viewBy);

  const dimension = VIEW_BY_DIMENSION_MAP[viewBy];

  return (
    <Header>
      <TitleGroup>
        <Title>Referral Details</Title>
        <DateRangeBadge startDate={startDate} endDate={endDate} />
      </TitleGroup>
      <RightGroup>
        <ReferralApiExport filename={getReferralExportFilename(viewBy)} params={getReferralExportParams(dimension)} />
      </RightGroup>
    </Header>
  );
}

const Header = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
